import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';

interface Props {
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  value: string;
  id?: string;
  name: string;
  required?: boolean;
}

/**
 * @description Investment round type name select form component.
 * @param {Props} props
 * @return {JSX.Element}
 */
const RoundTypeSelect = (props: Props): JSX.Element => {
  const name = props.name ?? 'roundType';
  const required = props.required ?? false;
  return (
    <Form.Select
      id={props.id}
      value={props.value}
      name={name}
      required={required}
      onChange={props.onChange}
    >
      <option value={''}>-- Select Round Type --</option>
      <option value="Equity Crowdfunding">Equity Crowdfunding</option>
      <option value="Grant">Grant</option>
      <option value="Pre-Seed">Pre-Seed</option>
      <option value="Seed">Seed</option>
      <option value="Series A">Series A</option>
      <option value="Series B">Series B</option>
      <option value="Series C">Series C</option>
      <option value="Series D">Series D</option>
      <option value="Series E">Series E</option>
      <option value="Series F">Series F</option>
      <option value="Series G">Series G</option>
      <option value="Series ?">Series ?</option>
    </Form.Select>
  );
};

export default RoundTypeSelect;
